$(function() {

  function initMostFunSlider() {
      var $slider = $("#app-h-mf-slider");

      $slider.on('init', function(event, slick, direction) {
          $slider.css("opacity", 1);
      });

      $slider.not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          // autoplay: true,
          // autoplaySpeed: 5000,
          responsive: [{
              breakpoint: 768,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                  dots: true
              }
          }]
      });
  }
  
  function init() {
      initMostFunSlider();
  }

  init();
});